import { dispatch, dispatchSync, useReframe } from 'nike-re-framejs';
import { useEffect, useState } from 'react';
import { getConfig } from '../../config';
import { PUSH_PATHS } from '../paths';
import { subscribePath, unsubscribePath } from '../pushSubscriptions';
import {
    matchDetailBetsClear,
    matchDetailMbmPush,
    matchDetailMbmSnapshot,
    matchDetailPush,
    matchDetailSnapshot
} from './handlers';
import { clearMbm } from '../overview/handlers/matchHandlers';
import { PushPayload } from '../../dto/PushEnvelope';
import { withVersionCheck } from '../versioningUtils';
import { DetailMarket } from '../../dto';
import { detailMarket$$, shouldCombinableMarketRender$ } from './subs';
import { COMBINABLE_BETS } from '../../components/detail/MarketCategories';

export function useMatchDetailPush(matchId: string): boolean {
    const channel = getConfig().channel;
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        let enabled = true;
        setLoaded(false);
        const path = PUSH_PATHS.matchDetailBets(matchId, channel);
        subscribePath(
            path,
            withVersionCheck({
                onSnapshot: data => {
                    if (!enabled) {
                        return;
                    }
                    dispatchSync(matchDetailSnapshot(data));
                    setLoaded(true);
                },
                onMessage: (data: PushPayload) => enabled && dispatch(matchDetailPush(data))
            })
        );
        return () => {
            enabled = false;
            unsubscribePath(path);
            dispatch(matchDetailBetsClear);
        };
    }, [matchId, channel]);
    return loaded;
}

export function useMbmPush(matchId: string, startSub: boolean) {
    useEffect(() => {
        if (!startSub) {
            return () => {};
        }
        const path = PUSH_PATHS.matchMbm(matchId);
        if (matchId) {
            subscribePath(path, {
                onSnapshot: data => dispatch(matchDetailMbmSnapshot(data)),
                onMessage: data => dispatch(matchDetailMbmPush(data))
            });
        }
        return () => {
            unsubscribePath(path);
            dispatch(clearMbm);
        };
    }, [matchId, startSub]);
}

export function useMarketsInGroup(market: DetailMarket, marketCategoryId) {
    const { subscribe } = useReframe();
    const marketFromGroupId = market?.groupIdInstancia;

    if (!marketFromGroupId) {
        return null;
    }
    const shouldMarketRender = subscribe(shouldCombinableMarketRender$(marketFromGroupId.toString()));

    if (marketCategoryId === COMBINABLE_BETS && !shouldMarketRender) {
        return null;
    }

    const marketFromGroup: DetailMarket = marketFromGroupId
        ? subscribe(detailMarket$$(marketFromGroupId.toString()))
        : null;

    return marketFromGroup;
}
